import { Box, Button, CircularProgress, Link, MenuItem, Select, TextField, Typography } from '@mui/material';
import { FC, useEffect, useRef, useState } from 'react';
import StorylineServerProxy  from "../storyline-proxy/storyline-proxy";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import WarningIcon from '@mui/icons-material/Warning';


interface LinkDetailsProp{
    link: string,
    scrapReport: any,
    handleCloseClicked: any,
    existingElement: any
}

export const LinkDetailsClassic: FC<LinkDetailsProp> = ({ link, scrapReport, handleCloseClicked, existingElement = null }) =>  {

    function findCategoryFromScraperName(scraperName){
        const news = /news?|press?/i;
        const jobs = /jobs?|careers?/i;
        const award = /award/i;
        const tender = /tender?s|bid|procurement/i;
        if (news.test(scraperName)) {
            return "News"
        } else if (jobs.test(scraperName)){
            return "Job"
        } else if (award.test(scraperName)){
            return "Contract award"
        } else if (tender.test(scraperName)){
            return "Call for tenders"
        } else {
            return "News"
        }
    }

    let [autoFillRunning, setAutoFillRunning] = useState(false);

    let [localLink, setLocalLink] = useState(link);
    let [autoTitleReady, setAutoTitleReady] = useState(false);
    let dateRef = useRef("");
    let titleRef = useRef("");
    let descriptionRef = useRef("");
    let typeRef = useRef("");

    let [extractedTitle, setExtractedTitle] = useState("");

    let [isInStoryline, setIsInStoryline] = useState(null as null | boolean);

    function resetForm(){
        setLocalLink("");
        if(titleRef.current){
            titleRef.current.value = "";
        }
        if(descriptionRef.current){
            descriptionRef.current.value = "";
        }
    }

    function handleCreateClick(){
        let storyElement = {
            title: titleRef.current.value,
            link: localLink,
            description: descriptionRef.current.value,
            type: typeRef.current.value,
            timestampFormatted: dateRef.current.value,
            timestamp: new Date(dateRef.current.value).getTime()
        }

        let functionToUse;
        if(existingElement != null){
             storyElement._id = existingElement._id;
             functionToUse = StorylineServerProxy.updateStoryElement;
        }
        else{
            functionToUse = StorylineServerProxy.createStoryElement;
        }

        functionToUse(storyElement).then(data => {
            resetForm();
            if(handleCloseClicked){
                handleCloseClicked();
            }    
        });
    }

    function autoFillForm(){
        setAutoFillRunning(true);
        if(existingElement == null){
            // NOTE: use localLink instead of link in case it has been changed or for manual use
            StorylineServerProxy.getLinkTitleAndDescription(localLink).then(titleAndDescription => { 
                titleRef.current.value = titleAndDescription.title;
                descriptionRef.current.value = titleAndDescription.description;
                setAutoTitleReady(true);
                setAutoFillRunning(false);
            });
            StorylineServerProxy.checkLinksUnicity([localLink]).then(includedLinks => setIsInStoryline(includedLinks.links.includes(localLink)));
        }
        else{
            titleRef.current.value = existingElement.title;
            setLocalLink(existingElement.link);
            descriptionRef.current.value = existingElement.description;
            dateRef.current.value = existingElement.timestampFormatted;
            typeRef.current.value = existingElement.type;
            setAutoTitleReady(true);
            setIsInStoryline(true);
            setAutoFillRunning(false);
        }
    }


    useEffect(() => {
        autoFillForm();
    }, []);

    return(
        <>
            <TextField placeholder="link" sx={{ width: 8/10 }} value={localLink} onChange={(event) => { setLocalLink(event?.target.value) }}></TextField>
            <Link href={ localLink } target="child"><OpenInNewIcon/></Link>
            { autoFillRunning?<CircularProgress />:<Button onClick={autoFillForm}>Auto fill</Button> }
            <br/>
            <TextField inputRef={dateRef} sx={{ width: 2/10 }} placeholder="Date" defaultValue={new Date(scrapReport?scrapReport.timestamp:new Date().getTime()).toISOString().substring(0, 10)}></TextField>
            <Select inputRef={typeRef} defaultValue={ scrapReport?findCategoryFromScraperName(scrapReport.scraper.name):"News" } sx={{ width: 2/10 }}>
                <MenuItem value="News">News</MenuItem>
                <MenuItem value="Call for tenders">Call for tenders</MenuItem>
                <MenuItem value="Contract award">Contract award</MenuItem>
                <MenuItem value="Job">Job</MenuItem>
            </Select>
            { isInStoryline == null?(<>Checking for duplicates...<CircularProgress /></>):(isInStoryline?<><WarningIcon/>Link is alredy in the storyline</>:<>Link is not in the storyline</>) }
            <br/>
            <br/>
            <TextField multiline inputRef={titleRef} sx={{ width: 9/10 }} placeholder="Title" />
            <Button onClick={() => { titleRef.current.value = titleRef.current.value.toLowerCase()}} sx={{ width: 1/10 }}>To lower</Button>
            <br/>
            <TextField inputRef={descriptionRef} multiline rows={4} sx={{ width: 10/10 }} placeholder="Description"></TextField>
            <br/>
            <Button onClick={() => { descriptionRef.current.value = descriptionRef.current.value.replace(/\n/g, " ").replace(/  /g, " ")}}>Trim</Button>
            <Button onClick={handleCreateClick}>{ (existingElement != null)?<>Update</>:<>Create</> }</Button>
        </>
    )
}